import './index.css';

let map = null;

let areaImage = require('./images/area.png');

let siteImage = require('./images/site.png');

export default {
  name: 'Bmap',
  props: {
    id: { type: String, default: () => (`b-map-${Math.random().toString().substring(2)}`) },
    mapKey: { type: String, default: () => '5b9d39bba940bc041864d83fb325afd4' },
    mapStyle: { type: String, default: () => 'amap://styles/3c227c09b6ee2f827d977bd2f7ce4ddd' },
    areas: { type: Object, default: () => ({}) },
    sites: { type: Object, default: () => ({}) },
    colors: { type: Array, default: () => [] },
    height: { type: String, default: () => '100vh' },
    version: { type: String, default: () => '2.0' },
    siteSize: { type: Number, default: () => 20 },
    areaIcon: { type: String, default: () => `<div class="icon"><img src="${areaImage}"/><div class="point"><div class="node"></div><div class="step1"></div><div class="step2"></div><div class="step3"></div></div></div>` },
    siteIcon: { type: String, default: () => `<div class="site-icon"><img src="${siteImage}"/></div>` },
    markers: { type: Array, default: () => [] },
    zoom: { type: Number, default: () => 14 },
    position: { type: Array, default: () => [112.819067, 31.126895] },
    coordinates: { type: Array, default: () => [] },
  },
  data() {
    return {
      scale: 7,
      loading: false,
    }
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  watch: {
    markers(prevState, nextState) {
      if (prevState != nextState) this.create();
    }
  },
  methods: {
    create() {
      this.scale = this.zoom;
      this.loading = true;
      let timeout = null;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          this.loading = false;
          clearTimeout(timeout);
          timeout = null;
        }, 5000);
      }
      // eslint-disable-next-line no-undef
      AMapLoader.load({ // 首次调用 load
        key: this.mapKey, // 首次load key为必填
        version: this.version, // 地图版本号
        // plugins: ['AMap.Scale', 'AMap.ToolBar'], // 地图插件
      }).then((AMap) => {
        map = new AMap.Map(this.id, {
          mapStyle: this.mapStyle,
          resizeEnable: true,
          center: this.position,
          zoom: this.scale,
          zoomEnable: true,
          dragEnable: true,
        });
        map.panTo(this.position);
        map.clearMap();  // 清除地图覆盖物(地图覆盖物初始化)
        this.markers && this.markers.length > 0 && this.markers.forEach((a, b) => { // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
          if (b < this.siteSize) {
            const marker = new AMap.Marker({
              map,
              id: a.id,
              title: a.title,
              clickable: true,
              position: a.position,
              content: this.areaIcon,
              offset: new AMap.Pixel(-13, -30), // 设置文本标注偏移量
              label: {
                direction: 'top',
                offset: new AMap.Pixel(10, 0), // 设置文本标注偏移量
                content: `<div class="marker-label-info">${a.name}</div>`, //设置文本标注内容
              }
            });
            marker.on('click', this.select);
            marker.on('mouseover', this.mouseover);
          }
        });
        const siteFeatures = this.sites.features;
        const areaFeatures = this.areas.features;
        siteFeatures && siteFeatures.length > 0 && siteFeatures.forEach(a => {
          new AMap.Marker({
            map,
            id: a.properties.adcode,
            content: this.siteIcon,
            position: a.geometry.coordinates,
            offset: new AMap.Pixel(-13, -30),
            title: a.properties.ext_path,
            label: {
              direction: 'top',
              offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
              content: `<div class="marker-label-info">${a.properties.name}</div>`, //设置文本标注内容
            }
          });
        });
        areaFeatures && areaFeatures.length > 0 && areaFeatures.forEach((a, b) => new AMap.Polygon({
          map,
          fillOpacity: 0.5,
          fillColor: this.colors[b],
          id: a.properties.adcode,
          path: a.geometry.coordinates, // 地图区域
        }));
        this.loading = false;
      }).catch((e) => {
        this.loading = false;
        console.error(e);
      });
    },
    select(e) {
      this.$emit('select', e);
    },
    mouseover(e) {
      this.$emit('mouseover', e);
    },
    cancel() {
      map && map.destroy();
      map = null;
    },
  },
  render() {
    return <div id={this.id} class="b-map" v-loading={this.loading} style={{ height: this.height }} />
  }
}